import { Editor, Frame, SerializedNodes } from "@craftjs/core";
import { ReactNode } from "react";
import "./assets/page-editor.css";
import RegionManager from "./components/RegionManager";
import RenderNode from "./components/RenderNode";
import Viewport from "./components/Viewport";
import { resolver } from "./resolver";

interface PageEditorProps {
    children?: ReactNode;
    data?: string | SerializedNodes;
    slug?: string;
}

const PageEditor = ({ children, data, slug }: PageEditorProps) => {
    return (
        <>
            <RegionManager />
            <Editor resolver={resolver} enabled={true} onRender={RenderNode}>
                {children}

                <Viewport data={data} slug={slug} enabled={true}>
                    <Frame />
                </Viewport>
            </Editor>
        </>
    );
};

export default PageEditor;
